<h1 class="title">
  <ng-content></ng-content>
</h1>